import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { RouteListItem } from '../types';
import type { PaginatedResponse } from '@shared/types';

interface UseRoutesParams {
  name?: string;
  page?: number;
  size?: number;
}

export function useRoutes(params: UseRoutesParams = {}) {
  const { name, page = 0, size = 25 } = params;
  const searchParams: Record<string, string> = {
    page: String(page + 1),
    size: String(size),
  };
  if (name) searchParams.name = name;

  return useQuery({
    queryKey: [...queryKeys.routes.all, params],
    queryFn: () => apiClient.get<PaginatedResponse<RouteListItem>>('/routes', searchParams),
  });
}
